/**
 * Feature Flags for Smart Prompt
 *
 * Toggle features on/off for controlled rollout and safe experimentation.
 * All flags default to false for safety.
 */

export const FeatureFlags = {
  /**
   * FF_RESULTS_CONSENSUS: Gates the new Consensus UI
   *
   * When enabled (true):
   * - Shows "Consensus" tab in comparison detail view
   * - Provides Heatmap, Narrative, and Wheel views
   * - Replaces legacy "Diffs" concept with multi-model agreement analysis
   *
   * When disabled (false):
   * - Legacy Outputs/Scores/Diffs only
   *
   * Rollback: Set to false to revert immediately (no DB migrations involved)
   */
  FF_RESULTS_CONSENSUS: true as boolean,
} as const;

export type FeatureFlagKey = keyof typeof FeatureFlags;

/**
 * Check if a feature flag is enabled
 * @param flag - The feature flag key to check
 * @returns true if the flag is enabled, false otherwise
 */
export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  return FeatureFlags[flag];
}

/**
 * Get all enabled feature flags
 * @returns Array of enabled feature flag keys
 */
export function getEnabledFeatures(): FeatureFlagKey[] {
  return (Object.keys(FeatureFlags) as FeatureFlagKey[]).filter(
    (key) => FeatureFlags[key]
  );
}
